export default "__VITE_ASSET__21df1731__"